import {
  CreateSetupIntentResponseDto,
  getRandomId,
  UserType,
} from "@ecologi/shared";
import { fetchFromAPI } from "./fetch-from-api";

export const confirmPaymentIntent = async (
  paymentIntentId: string,
  paymentMethod: string
) =>
  fetchFromAPI("/payments/confirm-payment-intent", {
    body: JSON.stringify({
      paymentIntentId,
      paymentMethod,
      idempotencyKey: getRandomId(),
    }),
    method: "POST",
  });

export const setupSubscriptionIntent = async ({
  captchaToken,
  paymentMethodId,
}: {
  captchaToken: string;
  paymentMethodId: string;
}): Promise<CreateSetupIntentResponseDto> =>
  fetchFromAPI("/payments/setup-intent", {
    body: JSON.stringify({
      captchaToken,
      paymentMethodId,
      idempotencyKey: getRandomId(),
    }),
    method: "POST",
  });

export const updatePaymentMethodDetails = async ({
  paymentMethodId,
}: {
  paymentMethodId: string;
}): Promise<UserType> =>
  fetchFromAPI("/payments/update-card-details", {
    body: JSON.stringify({
      paymentMethodId,
    }),
    method: "POST",
  });
